import { render } from "./ODAppointmentCard.vue?vue&type=template&id=82a68814"
import script from "./ODAppointmentCard.vue?vue&type=script&lang=js"
export * from "./ODAppointmentCard.vue?vue&type=script&lang=js"

import "./ODAppointmentCard.vue?vue&type=style&index=0&id=82a68814&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__